import app from 'app';
import templateUrl from './fileUploader.html';
import './fileUploader.scss';
import './fileUploaderInput';

import '@collectivehealth/dls-icons/dist/es/elements/dls-icon-documents';

function FileUploader($element) {
  /* Logic to create hover effect on dragover and remove on dragout or successful file drop
   */
  const dragTarget = $element.children();
  dragTarget.on('dragover', function (ev) {
    ev.preventDefault();
    this.className = 'FileUploader__targetDragOver';
  });

  dragTarget.on('dragleave', function (ev) {
    ev.preventDefault();
    this.className = 'FileUploader__target';
  });

  dragTarget.on('drop', function () {
    this.className = 'FileUploader__target';
  });
}

app.component('fileUploader', {
  bindings: {
    files: '=',
    maxFiles: '<',
    maxFileSize: '<',
    showMaxFilesError: '=',
  },
  controller: FileUploader,
  controllerAs: 'FileUploader',
  templateUrl,
});

export default 'fileUploader';
